import AuthorizationForm from "./AuthorizationForm";

export default class Field
{
    private element: JQuery;
    private error: JQuery;
    private valid: boolean = undefined;

    constructor(
        form: AuthorizationForm,
        element: any,
        private validate: (value: string, field: Field) => void
    ) {
        this.element  = $(element, form.element);
        this.error    = $(this.element.attr('data-error'));
    }

    initialize(): void
    {
        this.element.on('change', () => this.validate(this.getValue(), this));
    }

    setSuccess(): void
    {
        this.element.parent().removeClass("invalid");
        this.error
            .hide()
            .empty();
        this.valid = true;
    }

    setError(message: string = ''): void
    {
        this.element.parent().addClass("invalid");
        this.error
            .html(message)
            .show();
        this.valid = false;
    }

    setDisabled(disabled: boolean): void
    {
        this.element.prop('disabled', disabled);
    }

    setReadOnly(readonly: boolean): void
    {
        this.element.prop('readonly', readonly);
    }

    isValid(): boolean
    {
        if (typeof this.valid === "undefined") {
            this.validate(this.getValue(), this);
        }
        return this.valid;
    }

    reset(): void
    {
        this.valid = undefined;
        this.element.val('');
        this.setSuccess();
    }

    getValue(): string
    {
        return this.element.val() as string;
    }

    focus(): void
    {
        this.element[0].focus();
    }
};